export class WhatsAppUazapiSellerConfig {
  public id: number = 0;
  public guidclientenapis: string = "";
  public seller_id: number = 0;
  public provider: string = "";
  public base_url: string = "";
  public instance_name: string = "";
  public instance_token: string = "";
  public numero_whatsapp: string = "";
  public usa_whats_tipo: string = "";
  public status: string = "";
  public qrcode: string = "";
  public paircode: string = "";
  public profile_name: string = "";
  public is_uazapi: boolean = false;
  public conectado: boolean = false;
  public precisa_reconectar: boolean = false;
  public mensagem: string = "";
  public is_active: boolean = false;
  public configuracao_inexistente: boolean = false;
}
